module.exports = __webpack_public_path__ + "img/baidu.3f14172a.svg";